import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSectionA } from '../components/sections/ProblemSectionA';
import { CostComparisonSection } from '../components/sections/CostComparisonSection';
import { CaseStudiesSection } from '../components/sections/CaseStudiesSection';
import { FunnelSection } from '../components/sections/FunnelSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { RevenueProjectionSection } from '../components/sections/RevenueProjectionSection';
import { RepsOverTimeSection } from '../components/sections/RepsOverTimeSection';
import { RecruitingCostCalculator } from '../components/sections/RecruitingCostCalculator';
import { AuthoritySection } from '../components/sections/AuthoritySection';
import { ObjectionSection } from '../components/sections/ObjectionSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { FooterSection } from '../components/sections/FooterSection';
export function LandingPage() {
  return <div className="w-full min-h-screen font-sans" data-id="element-799">
      <HeroSection data-id="element-800" />
      <ProblemSectionA data-id="element-801" />
      <CostComparisonSection data-id="element-802" />
      <CaseStudiesSection data-id="element-803" />
      <FunnelSection data-id="element-804" />
      <HowItWorksSection data-id="element-805" />
      <RevenueProjectionSection data-id="element-806" />
      <RepsOverTimeSection data-id="element-807" />
      <RecruitingCostCalculator data-id="element-808" />
      <AuthoritySection data-id="element-809" />
      <ObjectionSection data-id="element-810" />
      <GuaranteeSection data-id="element-811" />
      <FooterSection data-id="element-812" />
    </div>;
}